/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Blog Bizo
 */

import { Bizo, autoclass } from '../../shared/bizos/base'

export default autoclass('Blog', class Blog extends Bizo {}, {
  author: 'author',
  category: 'category',
  date: 'date',
  imageUrl: 'image_url',
  shortDescription: 'short_description',
  title: 'title',
  url: 'url',
})
